import styles from "../../../views/ReportView/ReportView.module.css";
import Swal from "sweetalert2";
import axios from "axios";

const BajaButton = ({ user, setUser }) => {
  const handleBaja = async () => {
    const id = user.dni;
    try {
      const res = await axios.post(process.env.REACT_APP_CASUALTY_PERSON_API, {
        id,
        newStatus: "Baja",
      });

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Correcto",
          text: "La Persona Humana se dio de baja correctamente",
        });
        setUser({
          ...user,
          status: "Baja",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message,
      });
    }
  };

  return (
    <button type="button" onClick={handleBaja} className={styles.altabaja}>
      Dar de Baja
    </button>
  );
};

export default BajaButton;
